export default __webpack_public_path__ + "static/media/sponsor-medina-firula-big.9aa38130.png";